import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {LaColorService} from '../colors/la-color.service';

/**
 * @group Round Buttons
 * @component Round Button
 * @description Round Button with icon and text
 */
@Component({
  selector: 'la-round-button',
  template: `
    <button type="button" class="la-round-button" (click)="onClick()" [ngClass]="{
        'la-round-button--hover': isHover,
        'la-round-button--x-small': size === 'xsm',
        'la-round-button--small': size === 'sm',
        'la-round-button--medium': size === 'md',
        'la-round-button--disabled': isDisabled}" [disabled]="isDisabled"
            [style.background-color]="bgColor">
      <ng-content></ng-content>
    </button>`,
  styles: [`
    .la-round-button{padding:0;height:54px;width:54px;color:#fff;border-radius:50%;background:#23be9e;cursor:pointer;text-align:center;border:none}.la-round-button--hover,.la-round-button:hover{opacity:.6}.la-round-button.la-round-button--disabled{color:rgba(3,20,34,.15);background:rgba(3,20,34,.15)!important;border:1px solid rgba(3,20,34,.15);cursor:not-allowed}.la-round-button.la-round-button--disabled la-icon>svg{fill:rgba(3,20,34,.15)!important}.la-round-button .la-icon{max-height:54px;max-width:54px}.la-round-button--x-small{height:24px;width:24px;line-height:3.4px}.la-round-button--x-small .la-icon{max-height:24px;max-width:24px}.la-round-button--small{height:34px;width:34px;line-height:3.4px}.la-round-button--small .la-icon{max-height:34px;max-width:34px}.la-round-button--medium{height:44px;width:44px}.la-round-button--medium .la-icon{max-height:44px;max-width:44px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaRoundButtonComponent {
  private _isDisabled = false;
  private _isHover = false;
  private _size = 'large'; // default large, xsm,sm, md
  private _colorName: string; // color name
  public bgColor: string; // HEX or rgba CSS color
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  constructor(private _laColorService: LaColorService) {
  }

  onClick() {
    if (!this.isDisabled) {
      this.clicked.next();
    }
  }

  // [isDisabled]
  get isDisabled(): boolean {
    return this._isDisabled;
  }

  /**
   * true - to make button disabled. false - by default
   */
  @Input()
  set isDisabled(value: boolean) {
    this._isDisabled = value;
  }

  get isHover(): boolean {
    return this._isHover;
  }

  /**
   * To apply hovered style to a button. only used in style guide
   */
  @Input()
  set isHover(value: boolean) {
    this._isHover = value;
  }

  get size(): string {
    return this._size;
  }

  /**
   * size: to apply size into button
   */
  @Input()
  set size(value: string) {
    this._size = value;
  }

  get color(): string {
    return this._colorName;
  }

  /**
   * To apply color to button bg color. support only color palates color.
   */
  @Input()
  set color(colorName: string) {
    this._colorName = colorName.toLowerCase();
    this.bgColor = this._laColorService.getColorByName(colorName);
  }
}
